module.exports = __webpack_public_path__ + "static/media/photography.a1a14e43.png";